import { ShieldCheck } from "lucide-react";
import SecurityBadge from "../SecurityBadge";
import { VAULT_IMG } from "../../lib/site";

const PILLARS = [
  { t: "AES-256 at Rest", d: "Every record is encrypted with the same standard used by federal agencies." },
  { t: "TLS 1.3 in Transit", d: "Modern transport encryption on every request, verified quarterly." },
  { t: "SOC 2 Aligned", d: "Independently reviewed controls covering access, availability, and confidentiality." },
  { t: "Zero-Trust Access", d: "Least-privilege internal permissions. Every action logged and audited." },
];

export default function SecuritySection() {
  return (
    <section className="relative overflow-hidden bg-[#0A1128] py-28 lg:py-36">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-6">
          <img src={VAULT_IMG} alt="Gold vault door detail" className="h-[540px] w-full object-cover" />
        </div>
        <div className="lg:col-span-6 lg:pl-8">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">Security & Trust</div>
          <h2 className="mt-4 font-serif text-4xl font-light leading-tight sm:text-5xl">
            Bank-grade infrastructure.
            <br />
            <span className="italic text-[#D4AF37]">Boutique-level trust.</span>
          </h2>

          <div className="mt-8">
            <SecurityBadge />
          </div>

          <div className="mt-10 grid gap-6 sm:grid-cols-2">
            {PILLARS.map((b) => (
              <div key={b.t} className="flex gap-4">
                <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-[#D4AF37]" strokeWidth={1.5} />
                <div>
                  <div className="text-xs uppercase tracking-[0.24em] text-white">{b.t}</div>
                  <p className="mt-1 text-xs text-white/60">{b.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
